/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Link_TitleInputs */

const en_link_title = /** @type {(inputs: Link_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link Title`)
};

const id_link_title = /** @type {(inputs: Link_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Judul Tautan`)
};

/** @type {(inputs: Link_TitleInputs) => LocalizedString} */
const es_link_title = en_link_title;

/** @type {(inputs: Link_TitleInputs) => LocalizedString} */
const fr_link_title = en_link_title;

/** @type {(inputs: Link_TitleInputs) => LocalizedString} */
const de_link_title = en_link_title;

/** @type {(inputs: Link_TitleInputs) => LocalizedString} */
const ja_link_title = en_link_title;

/** @type {(inputs: Link_TitleInputs) => LocalizedString} */
const zh_link_title = en_link_title;

/** @type {(inputs: Link_TitleInputs) => LocalizedString} */
const ar_link_title = en_link_title;

/** @type {(inputs: Link_TitleInputs) => LocalizedString} */
const it_link_title = en_link_title;

/** @type {(inputs: Link_TitleInputs) => LocalizedString} */
const ru_link_title = en_link_title;

/** @type {(inputs: Link_TitleInputs) => LocalizedString} */
const pt_link_title = en_link_title;

/** @type {(inputs: Link_TitleInputs) => LocalizedString} */
const ko_link_title = en_link_title;

/**
* | output |
* | --- |
* | "Link Title" |
*
* @param {Link_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const link_title = /** @type {((inputs?: Link_TitleInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Link_TitleInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_link_title(inputs)
	if (locale === "es") return es_link_title(inputs)
	if (locale === "fr") return fr_link_title(inputs)
	if (locale === "de") return de_link_title(inputs)
	if (locale === "ja") return ja_link_title(inputs)
	if (locale === "zh") return zh_link_title(inputs)
	if (locale === "ar") return ar_link_title(inputs)
	if (locale === "id") return id_link_title(inputs)
	if (locale === "it") return it_link_title(inputs)
	if (locale === "ru") return ru_link_title(inputs)
	if (locale === "pt") return pt_link_title(inputs)
	return ko_link_title(inputs)
});